export const DEFAULT_INTERNET_AGREEMENT = `<h1>Livestream Booking Agreement &amp; Client Acknowledgement Form</h1>
<h3>EVENT DETAILS</h3>
<p><strong>Event Name: <span class="agreement-field">{eventName}</span></strong></p>
<p><strong>Venue: <span class="agreement-field">{serviceVenue}</span></strong></p>
<p><strong>Event Date: <span class="agreement-field">{serviceDate}</span></strong></p>
<p><strong>Livestream Start Time: <span class="agreement-field">{serviceTime}</span></strong></p>
<p><strong>Client Name: <span class="agreement-field">{clientName}</span></strong></p>
<p><strong>Contact Number: <span class="agreement-field">{clientPhone}</span></strong></p>
<p><strong>Email Address: <span class="agreement-field">{clientEmail}</span></strong></p>

<h2>INTERNET ACKNOWLEDGEMENT</h2>
<p>Muzukuru recommends the use of a dedicated wired Ethernet connection wherever possible to maximise the stability and quality of the livestream.</p>
<p>The Client acknowledges that internet services are provided by third-party providers and are outside Muzukuru's control. While every reasonable effort will be made to deliver a reliable livestream, interruptions, reduced quality or complete loss of transmission may occur due to internet instability, network congestion or service outages.</p>
<p class="agreement-acknowledgement">☐ I understand and accept the risks associated with internet connectivity during the livestream.</p>

<h2>COPYRIGHT ACKNOWLEDGEMENT</h2>
<p>The Client acknowledges that any copyrighted music, videos or other protected media played during the livestream may result in copyright claims from platforms including YouTube and Facebook.</p>
<p>The Client accepts full responsibility for obtaining any necessary permissions or licences for copyrighted material used during the event.</p>
<p>Muzukuru shall not be held liable for:</p>
<ul><li>Copyright strikes or claims</li><li>Muted sections of the livestream</li><li>Removal or blocking of the livestream</li><li>Restrictions placed on the recording by streaming platforms</li></ul>
<p class="agreement-acknowledgement">☐ I understand and accept the Copyright Policy.</p>

<h2>CLIENT RESPONSIBILITIES</h2>
<p>The Client agrees to:</p>
<ul><li>Provide venue access at the agreed arrival time.</li><li>Ensure reliable electrical power is available throughout the event.</li><li>Provide access to the agreed internet connection.</li><li>Inform Muzukuru of any significant programme changes before the livestream begins.</li><li>Ensure all necessary permissions have been obtained from the venue where required.</li></ul>

<h2>TECHNICAL LIMITATIONS</h2>
<p>While Muzukuru uses professional equipment and follows industry best practices, the Client understands that certain circumstances are beyond our control.</p>
<p>These include but are not limited to:</p>
<ul><li>Internet outages</li><li>Power failures</li><li>Equipment failure</li><li>Venue restrictions</li><li>Streaming platform outages (YouTube, Facebook, etc.)</li></ul>
<p>Muzukuru shall not be held liable for interruptions caused by circumstances beyond its reasonable control.</p>
<p class="agreement-acknowledgement">☐ I understand and accept these technical limitations.</p>

<h2>CANCELLATION &amp; RESCHEDULING POLICY</h2>
<h3>Cancellation by the Client</h3>
<p>If the booking is cancelled:</p>
<ul><li><strong>More than 14 days before the event:</strong> No cancellation fee. Any deposit paid remains non-refundable but may be transferred to another booking within six (6) months.</li><li><strong>Between 7 and 14 days before the event:</strong> 50% of the total booking value becomes payable.</li><li><strong>Less than 7 days before the event:</strong> 75% of the total booking value becomes payable.</li><li><strong>Within 48 hours of the event, or after the crew has been dispatched:</strong> 100% of the booking value is payable.</li></ul>
<h3>Cancellation by Muzukuru</h3>
<p>Should Muzukuru be unable to provide the agreed service due to unforeseen circumstances beyond our reasonable control, every effort will be made to provide an alternative crew or reschedule the booking. If neither option is possible, any monies paid will be refunded in full.</p>
<p>Muzukuru reserves the right to waive or reduce cancellation fees in exceptional circumstances at its sole discretion.</p>
<p class="agreement-acknowledgement">☐ I have read and understand the Cancellation &amp; Rescheduling Policy.</p>

<h2>FORCE MAJEURE</h2>
<p>Neither party shall be liable for failure to perform its obligations where such failure is caused by circumstances beyond reasonable control, including but not limited to:</p>
<ul><li>Severe weather</li><li>Civil unrest</li><li>Government restrictions</li><li>Acts of God</li><li>Venue closure</li><li>Widespread power outages</li><li>Internet service provider failures</li></ul>

<h2>RECORDING &amp; DELIVERY</h2>
<p>A recording of the livestream will be provided after the event on a flashstick with a $30 charge.</p>
<p>Although backup recordings are made wherever reasonably possible, Muzukuru cannot guarantee recovery of recordings in the event of equipment failure or other circumstances beyond our reasonable control.</p>
<p class="agreement-acknowledgement">☐ I understand the Recording &amp; Delivery Policy.</p>

<h2>CLIENT DECLARATION</h2>
<p>I confirm that I have read, understood and agreed to the terms and conditions contained in this Livestream Booking Agreement &amp; Client Acknowledgement Form.</p>
<p>Client Name: _____________________________________________</p>
<p>Signature: _______________________________________________</p>
<p>Date: _________________________________________________</p>

<h3>MUZUKURU REPRESENTATIVE</h3>
<p>Representative Name: _____________________________________</p>
<p>Signature: _______________________________________________</p>
<p>Date: _________________________________________________</p>`;

export const isLegacyInternetAgreement = (content: string) =>
  content.includes(
    "As Muzukuru Livestreaming Company, we advise utilizing a",
  ) || content.includes("Internet Agreement & Copyright Disclaimer Form");

export const removeAgreementPageBreaks = (content: string) =>
  content.replace(
    /<p>\s*\[\[PAGE_BREAK\]\]\s*<\/p>|\[\[PAGE_BREAK\]\]/gi,
    "",
  );

const ACKNOWLEDGEMENTS = [
  "I understand and accept the risks associated with internet connectivity during the livestream.",
  "I understand and accept the Copyright Policy.",
  "I understand and accept these technical limitations.",
  "I have read and understand the Cancellation & Rescheduling Policy.",
  "I understand the Recording & Delivery Policy.",
];

export const ensureAgreementCheckboxes = (content: string) => {
  let result = content;
  ACKNOWLEDGEMENTS.forEach((text) => {
    [text, text.replaceAll("&", "&amp;")].forEach((variant) => {
      result = result.replace(
        `<p>${variant}</p>`,
        `<p class="agreement-acknowledgement">☐ ${variant}</p>`,
      );
    });
  });
  return result;
};
